import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { LoadingService } from './services/util/loading.service';

declare var $: any;

@Component({
    selector: 'app-my-app',
    templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {
    constructor(private elRef: ElementRef,
        private loadingService: LoadingService
    ) {
    }

    ngOnInit() { 
        $.material.init();
        const body = document.getElementsByTagName('body')[0];
        const isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;
        if (isWindows) {
           // if we are on windows OS we activate the perfectScrollbar function
            body.classList.add('perfect-scrollbar-on');
        } else {
            body.classList.add('perfect-scrollbar-off');
        }
        $.material.init();
    }

    showSpinner() {
        return this.loadingService.mustShowSpinner();
    }
}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/app.component.ts